/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Agroevidence API
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios';
import type {
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

export type FarmType = typeof FarmType[keyof typeof FarmType];


export const FarmType = {
  CLEVER_FARM: 'CLEVER_FARM',
  CLEVER_GREEN: 'CLEVER_GREEN',
} as const;

export interface FarmTypeUpdateTo {
  farmType: FarmType;
}

export type Module = typeof Module[keyof typeof Module];


export const Module = {
  maplayers: 'map.layers',
  mapparcels: 'map.parcels',
  mapthematic_maps: 'map.thematic_maps',
  maptelematics: 'map.telematics',
  precision_farming: 'precision_farming',
  precision_farmingmachine_data: 'precision_farming.machine_data',
  precision_farmingprescription_maps: 'precision_farming.prescription_maps',
  telematics: 'telematics',
  irrigation: 'irrigation',
  activities: 'activities',
  stores: 'stores',
  reports: 'reports',
  catalogues: 'catalogues',
} as const;

export interface ModulesUpdateTo {
  disabledModules: Module[];
}

export interface InternalFarmCreate {
  id: string;
  countryCode: string;
  userId: string;
  farmType: FarmType;
}

export interface FarmUserTo {
  farmId: string;
  userId: string;
  email: string;
}

export interface InternalFarmUser {
  userId: string;
}

export interface InternalFarm {
  id: string;
  countryCode: string;
}

export interface DisabledModulesTo {
  disabledModules: Module[];
}

export interface FarmTypeTo {
  farmType: FarmType;
}

export interface DisabledModuleTemplateTo {
  farmType: FarmType;
  disabledModules: Module[];
}

export interface FarmTo {
  id: string;
  countryCode: string;
}

type AdminGetFarmTypeParamsTSMorphBase = {
farmIds: string;
}

export type AdminGetFarmTypeParams = Omit<AdminGetFarmTypeParamsTSMorphBase, "farmIds">;;

type AdminSetFarmTypeParamsTSMorphBase = {
farmIds: string;
}

export type AdminSetFarmTypeParams = Omit<AdminSetFarmTypeParamsTSMorphBase, "farmIds">;;

type AdminGetDisabledModulesParamsTSMorphBase = {
farmIds: string;
}

export type AdminGetDisabledModulesParams = Omit<AdminGetDisabledModulesParamsTSMorphBase, "farmIds">;;

type AdminDisableModulesParamsTSMorphBase = {
farmIds: string;
}

export type AdminDisableModulesParams = Omit<AdminDisableModulesParamsTSMorphBase, "farmIds">;;

type GetFarmUsersParamsTSMorphBase = {
farmIds: string;
}

export type GetFarmUsersParams = Omit<GetFarmUsersParamsTSMorphBase, "farmIds">;;

export type AddFarmUserParams = {
farmIds: string;
'user-id': string;
};

export type DeleteFarmUserParams = {
farmIds: string;
'user-id': string;
};

type GetInternalFarmUsersParamsTSMorphBase = {
farmIds: string;
}

export type GetInternalFarmUsersParams = Omit<GetInternalFarmUsersParamsTSMorphBase, "farmIds">;;

export type GetFarmsByUserIdParams = {
'user-id': string;
};

type GetDisabledModulesParamsTSMorphBase = {
farmIds: string;
}

export type GetDisabledModulesParams = Omit<GetDisabledModulesParamsTSMorphBase, "farmIds">;;

export type GetFarmsByUserId1Params = {
'user-id': string;
};

/**
 * Returns the farm type label for the specified farm
 * @summary Get the farm type
 */
export const adminGetFarmType = (
    params: AdminGetFarmTypeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FarmTypeTo>> => {
    return axios.get(
      `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/modules/type`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Sets the farm type label. The farm's stored module configuration is not affected.
 * @summary Set the farm type
 */
export const adminSetFarmType = (
    farmTypeUpdateTo: FarmTypeUpdateTo,
    params: AdminSetFarmTypeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.put(
      `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/modules/type`,
      farmTypeUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns the set of disabled module keys for the specified farm
 * @summary Get the farm's disabled modules
 */
export const adminGetDisabledModules = (
    params: AdminGetDisabledModulesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DisabledModulesTo>> => {
    return axios.get(
      `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/modules/disabled`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Replaces the set of disabled module keys for the specified farm in one call
 * @summary Set the farm's disabled modules
 */
export const adminDisableModules = (
    modulesUpdateTo: ModulesUpdateTo,
    params: AdminDisableModulesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.put(
      `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/modules/disabled`,
      modulesUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a new farm with the provided information
 * @summary Create a new farm
 */
export const createFarm = (
    internalFarmCreate: InternalFarmCreate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `${window.ENV.FARM_MANAGEMENT_URL}/internal-api/farms`,
      internalFarmCreate,options
    );
  }

/**
 * Retrieves all users associated with the specified farm ID
 * @summary Get users for a farm
 */
export const getFarmUsers = (
    params: GetFarmUsersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FarmUserTo[]>> => {
    return axios.get(
      `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/users`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Adds a user to a farm with the specified IDs
 * @summary Add a user to a farm
 */
export const addFarmUser = (
    params: AddFarmUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FarmUserTo>> => {
    return axios.post(
      `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/users`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Removes a user from a farm with the specified IDs
 * @summary Remove a user from a farm
 */
export const deleteFarmUser = (
    params: DeleteFarmUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/users`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Retrieves all users associated with the specified farm ID
 * @summary Get users for a farm
 */
export const getInternalFarmUsers = (
    params: GetInternalFarmUsersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalFarmUser[]>> => {
    return axios.get(
      `${window.ENV.FARM_MANAGEMENT_URL}/internal-api/farms/users/by-farm`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Retrieves all farms associated with the specified user ID
 * @summary Get farms by user ID
 */
export const getFarmsByUserId = (
    params: GetFarmsByUserIdParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalFarm[]>> => {
    return axios.get(
      `${window.ENV.FARM_MANAGEMENT_URL}/internal-api/farms/by-user`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns the set of disabled module keys for the specified farm
 * @summary Get the farm's disabled modules
 */
export const getDisabledModules = (
    params: GetDisabledModulesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DisabledModulesTo>> => {
    return axios.get(
      `${window.ENV.FARM_MANAGEMENT_URL}/api/farms/modules/disabled`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns the default disabled module keys for every farm type. Read-only: applying a template is a separate call to PUT /disabled.
 * @summary Get the disabled module templates
 */
export const adminGetDisabledModuleTemplates = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DisabledModuleTemplateTo[]>> => {
    return axios.get(
      `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/modules/disabled/templates`,options
    );
  }

/**
 * Retrieves all farms associated with the specified user ID
 * @summary Get farms by user ID
 */
export const getFarmsByUserId1 = (
    params: GetFarmsByUserId1Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FarmTo[]>> => {
    return axios.get(
      `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/by-user`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export type AdminGetFarmTypeResult = AxiosResponse<FarmTypeTo>
export type AdminSetFarmTypeResult = AxiosResponse<void>
export type AdminGetDisabledModulesResult = AxiosResponse<DisabledModulesTo>
export type AdminDisableModulesResult = AxiosResponse<void>
export type CreateFarmResult = AxiosResponse<void>
export type GetFarmUsersResult = AxiosResponse<FarmUserTo[]>
export type AddFarmUserResult = AxiosResponse<FarmUserTo>
export type DeleteFarmUserResult = AxiosResponse<void>
export type GetInternalFarmUsersResult = AxiosResponse<InternalFarmUser[]>
export type GetFarmsByUserIdResult = AxiosResponse<InternalFarm[]>
export type GetDisabledModulesResult = AxiosResponse<DisabledModulesTo>
export type AdminGetDisabledModuleTemplatesResult = AxiosResponse<DisabledModuleTemplateTo[]>
export type GetFarmsByUserId1Result = AxiosResponse<FarmTo[]>
